import { DatabaseRecord } from "@tellescope/types-models";

export interface DatabaseRecordLabelOptions {
  databaseLabel?: string;
  databaseLabels?: string[];
}

export const labelForDatabaseRecord = (
  { databaseLabel, databaseLabels }: DatabaseRecordLabelOptions,
  record: DatabaseRecord | undefined | null
): string => {
  if (!record) return "";

  const valueForColumn = (column: string) => record.values.find(({ label }) => label === column)?.value;

  const primaryValue = databaseLabel === undefined ? undefined : valueForColumn(databaseLabel);
  const primary = primaryValue === undefined || primaryValue === null ? "" : String(primaryValue);

  const suffixes =
    databaseLabels?.reduce<string[]>((acc, column) => {
      const value = valueForColumn(column);
      if (value === undefined || value === null) return acc;
      const asString = String(value);
      if (!asString.trim()) return acc;
      acc.push(asString);
      return acc;
    }, []) ?? [];

  return suffixes.length ? `${primary} (${suffixes.join(", ")})` : primary;
};
